module.exports = __webpack_public_path__ + "static/how-72d3221cdd538f1dea9ed82e66100a47.svg";